import PropTypes from 'prop-types'
import { calcularTotalItemConIva } from '../helpers/calcularPrecioTotal'
import Precios from '../reutilizables/precios/Precios'

const IVA_ENVIO = 1.21
const MAX_DECIMALES = 2
const AUMENTO_TIENDA_OFICIAL = 1

const DetalleCobro = ({
  cantidad,
  precio,
  porcentajeExposicion,
  exposicion,
  monedaSimbolo,
  alicuota,
  precioEnvio,
  esTiendaOficial
}) => {
  const precioUnitario = Number(precio) || 0
  const cantidadNumerica = Number(cantidad) || 1
  const alicuotaNumerica = Number(alicuota) || 0
  const porcentajeExposicionNumerico = Number(porcentajeExposicion) || 0
  const ventaTotal = calcularTotalItemConIva({
    precioUnitario,
    cantidad: cantidadNumerica,
    alicuota: alicuotaNumerica
  })
  const descuentoExposicion = (porcentajeExposicionNumerico * ventaTotal) / 100
  const descuentoTiendaOficial = esTiendaOficial ? (AUMENTO_TIENDA_OFICIAL * ventaTotal) / 100 : 0
  const envioConIva = (Number(precioEnvio) || 0) * IVA_ENVIO
  const totalCalculado = ventaTotal - descuentoExposicion - descuentoTiendaOficial + envioConIva
  const descuentoExposicionFormateado = Number(descuentoExposicion).toLocaleString('es-AR', {
    maximumFractionDigits: MAX_DECIMALES
  })
  const descuentoTiendaOficialFormateado = Number(descuentoTiendaOficial).toLocaleString('es-AR', {
    maximumFractionDigits: MAX_DECIMALES
  })

  return (
    <div className="row">
      <div className="col">
        <div className="row">
          <div className="col">
            <h3 className="text-left">Detalle de Cobro</h3>
          </div>
        </div>
        <div className="row">
          <div className="col ml-5 mr-5">
            <div className="row">
              <div className="col">
                <p>
                  <b>Descripción</b>
                </p>
              </div>
              <div className="col">
                <p>
                  <b>Importe</b>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <p>Venta (x {cantidad})</p>
              </div>
              <div className="col">
                <Precios
                  precio={precioUnitario}
                  monedaSimbolo={monedaSimbolo}
                  alicuota={alicuotaNumerica}
                  cantidad={cantidadNumerica}
                  showSinIVA={true}
                />
              </div>
            </div>
            {precioEnvio > 0 && (
              <div className="row">
                <div className="col-6">
                  <p className="">Envío</p>
                </div>
                <div className="col-6">
                  <Precios
                    precio={precioEnvio}
                    monedaSimbolo={monedaSimbolo}
                    alicuota={21}
                    showSinIVA={true}
                  />
                </div>
              </div>
            )}
            <div className="row mt-2">
              <div className="col-6">
                <p className="">
                  Exposición {exposicion} ({porcentajeExposicion}%)
                </p>
              </div>
              <div className="col-6">
                <p>
                  -
                  <b>
                    {monedaSimbolo}
                    {descuentoExposicionFormateado}
                  </b>
                </p>
              </div>
            </div>
            {esTiendaOficial && (
              <div className="row mt-2">
                <div className="col-6">
                  <p className="">Tienda Oficial (1%)</p>
                </div>
                <div className="col-6">
                  <p>
                    -
                    <b>
                      {monedaSimbolo}
                      {descuentoTiendaOficialFormateado}
                    </b>
                  </p>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col text-right">
                <b>Total</b>
              </div>
              <div className="col">
                <Precios
                  precio={totalCalculado}
                  monedaSimbolo={monedaSimbolo}
                  alicuota={0}
                  showSinIVA={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

DetalleCobro.propTypes = {
  precio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  cantidad: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  monedaSimbolo: PropTypes.string.isRequired,
  exposicion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  porcentajeExposicion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  alicuota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  precioEnvio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  esTiendaOficial: PropTypes.bool.isRequired
}

export default DetalleCobro
